import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pickup-display-page" }
const _hoisted_2 = { class: "pickup-header" }
const _hoisted_3 = { class: "pickup-brand" }
const _hoisted_4 = { class: "pickup-brand-mark" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "pickup-eyebrow" }
const _hoisted_8 = { class: "pickup-meta" }
const _hoisted_9 = { class: "pickup-meta-card" }
const _hoisted_10 = { class: "pickup-meta-card" }
const _hoisted_11 = { class: "pickup-meta-card" }
const _hoisted_12 = { class: "pickup-main" }
const _hoisted_13 = {
  key: 0,
  class: "pickup-grid"
}
const _hoisted_14 = { class: "pickup-card-label" }
const _hoisted_15 = {
  key: 1,
  class: "pickup-empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "pickup-orb orb-one" }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "pickup-orb orb-two" }, null, -1)),
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.brandLogo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.brandLogo,
                alt: `${_ctx.stateStore.siteName} logo`
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.brandInitial), 1))
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("pos.pickup_screen")), 1),
          _createElementVNode("h1", null, _toDisplayString(_ctx.stateStore.siteName), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("pos.pickup_display_description")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("article", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.counter")), 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.activeWarehouseLabel), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t("pos.ready_orders_refresh_automatically")), 1)
        ]),
        _createElementVNode("article", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.last_refresh")), 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.liveTime), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.liveDate), 1)
        ]),
        _createElementVNode("article", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.ready_orders")), 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.completedOrders.length), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.$t("pos.showing_latest_completed_tickets")), 1)
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_12, [
      (_ctx.completedOrders.length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.completedOrders, (order) => {
              return (_openBlock(), _createElementBlock("article", {
                key: order.id,
                class: "pickup-card"
              }, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("pos.waiting_number")), 1),
                _createElementVNode("strong", null, "#" + _toDisplayString(_ctx.getQueueLabel(order)), 1),
                _createElementVNode("h2", null, _toDisplayString(order.reference_no), 1),
                _createElementVNode("p", null, _toDisplayString(order.customer_name || _ctx.$t("pos.walk_in_customer")), 1),
                _createElementVNode("small", null, _toDisplayString(_ctx.$t("pos.ready_at")) + " " + _toDisplayString(_ctx.formatDateTime(order.queue_completed_at || order.created_at)), 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_15, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pickup-empty-mark" }, [
              _createElementVNode("i", { class: "ri-cup-line" })
            ], -1)),
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pos.no_completed_orders_yet")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("pos.completed_invoices_will_appear")), 1)
          ]))
    ])
  ]))
}